// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../img/Banners/WALLPAPER-Icontec-Desktop-2024_06.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    color: #000;
    overflow-x: hidden;
    height: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
    background-position: center;
    background-blend-mode: lighten;
    /* Combina la imagen con el color de fondo */
    background-color: rgba(255, 255, 255, 0.8);
    /* Fondo blanco semitransparente */
}

.card {
    padding: 30px 40px;
    margin-top: 60px;
    margin-bottom: 60px;
    border: none !important;
    box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.2);
}

.blue-text {
    color: #00BCD4;
}

.form-control-label {
    margin-bottom: 0;
}

input,
textarea,
button {
    padding: 8px 15px;
    border-radius: 5px !important;
    margin: 5px 0px;
    box-sizing: border-box;
    border: 1px solid #ccc;
    font-size: 18px !important;
    font-weight: 300;
}

input:focus,
textarea:focus {
    box-shadow: none !important;
    border: 1px solid #00BCD4;
    outline-width: 0;
    font-weight: 400;
}

.btn-block {
    text-transform: uppercase;
    font-size: 15px !important;
    font-weight: 400;
    height: 43px;
    cursor: pointer;
}

.btn-block:hover {
    color: #fff !important;
}

button:focus {
    box-shadow: none !important;
    outline-width: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/css/fomr.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,yDAAgF;IAChF,4BAA4B;IAC5B,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;IAC3B,8BAA8B;IAC9B,4CAA4C;IAC5C,0CAA0C;IAC1C,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,2CAA2C;AAC/C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;;IAGI,iBAAiB;IACjB,6BAA6B;IAC7B,eAAe;IACf,sBAAsB;IACtB,sBAAsB;IACtB,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;;IAII,2BAA2B;IAC3B,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IAGI,2BAA2B;IAC3B,gBAAgB;AACpB","sourcesContent":["body {\n    color: #000;\n    overflow-x: hidden;\n    height: 100%;\n    background-image: url(\"../../img/Banners/WALLPAPER-Icontec-Desktop-2024_06.jpg\");\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-attachment: fixed;\n    background-position: center;\n    background-blend-mode: lighten;\n    /* Combina la imagen con el color de fondo */\n    background-color: rgba(255, 255, 255, 0.8);\n    /* Fondo blanco semitransparente */\n}\n\n.card {\n    padding: 30px 40px;\n    margin-top: 60px;\n    margin-bottom: 60px;\n    border: none !important;\n    box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.2);\n}\n\n.blue-text {\n    color: #00BCD4;\n}\n\n.form-control-label {\n    margin-bottom: 0;\n}\n\ninput,\ntextarea,\nbutton {\n    padding: 8px 15px;\n    border-radius: 5px !important;\n    margin: 5px 0px;\n    box-sizing: border-box;\n    border: 1px solid #ccc;\n    font-size: 18px !important;\n    font-weight: 300;\n}\n\ninput:focus,\ntextarea:focus {\n    -moz-box-shadow: none !important;\n    -webkit-box-shadow: none !important;\n    box-shadow: none !important;\n    border: 1px solid #00BCD4;\n    outline-width: 0;\n    font-weight: 400;\n}\n\n.btn-block {\n    text-transform: uppercase;\n    font-size: 15px !important;\n    font-weight: 400;\n    height: 43px;\n    cursor: pointer;\n}\n\n.btn-block:hover {\n    color: #fff !important;\n}\n\nbutton:focus {\n    -moz-box-shadow: none !important;\n    -webkit-box-shadow: none !important;\n    box-shadow: none !important;\n    outline-width: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
